import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {MessageResponse} from "./message-response";
import {UrlsResources} from "../urls-resources";

@Injectable()
export class BannerService {
  constructor(private httpClient: HttpClient,
              protected urlsResources: UrlsResources) {
  }

  getMessagesOfBanner(): Observable<MessageResponse []> {
    const url = this.urlsResources.getMessagesOfBannerUrl();
    return this.httpClient.get<MessageResponse []>(url, {withCredentials: true});
  }

  getMessageOfBannerByMessageKey(messageKey: string): Observable<MessageResponse> {
    const url = this.urlsResources.getMessagesOfBannerByMessageKeyUrl(messageKey);
    return this.httpClient.get<MessageResponse>(url, {withCredentials: true});
  }

  saveMessageOfBanner(messageRequest): Observable<MessageResponse> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const url = this.urlsResources.saveMessageOfBannerUrl();
    return this.httpClient.post<MessageResponse>(url, messageRequest, {withCredentials: true, headers});
  }

  updateMessageOfBanner(messageRequest, messageKey): Observable<MessageResponse> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const url = this.urlsResources.updateMessageOfBannerUrl(messageKey);
    return this.httpClient.patch<MessageResponse>(url, messageRequest, {withCredentials: true, headers});
  }

  activeMessage(messageKey): Observable<any> {
    const url = this.urlsResources.changeStatusMessageUrl(messageKey);
    return this.httpClient.patch(url, null, {withCredentials: true});
  }

  deleteMessageOfBanner(messageKey): Observable<any> {
    const url = this.urlsResources.deleteMessageUrl(messageKey);
    return this.httpClient.delete(url, {withCredentials: true});
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/banner/banner.service.ts